// Gambar panel kanan di halaman login. Ganti nilai `image` dengan tautan
// gambar yang dipakai. Kalau isinya cuma satu slide, titik indikatornya
// otomatis disembunyikan.
export const LOGIN_SLIDES = [
  {
    image: 'https://assets.negara.co.id/uploads/2026/08/29/85ad3f11-53a5-4ed1-b60c-5a0c300aac01.jpg',
    title: 'Satu pintu untuk data keanggotaan',
    description:
      'Kelola pendaftaran, verifikasi korwil, sampai penerbitan kartu anggota dari satu tempat.',
  }
]

// Jeda pergantian slide, dalam milidetik.
export const LOGIN_SLIDE_INTERVAL = 6000
